import { Tabs } from '../../atoms/tabs'

type TabLabelProps = {
  id: string
  title: string
}

export const TabLabel = ({ id, title }: TabLabelProps) => (
  <Tabs.Trigger
    variant="outline"
    value={id}
    className="-mb-px border-transparent hover:bg-transparent data-[state=active]:border-neutral-900 data-[state=active]:bg-transparent data-[state=active]:text-neutral-600"
  >
    {title}
  </Tabs.Trigger>
)
